import {getConnection} from "@/api/context/connection";
import {
    LENDING_PROGRAM_ID_BONFIDA,
    LENDING_PROGRAM_ID,
    LP_RESERVE_IDS,
    RESERVE_IDS,
    LENDING_MARKET_CONFIGS, RESERVE_FULLNAMES
} from "@/api/constants/config";

import {
    Detail,
    Obligation,
    ObligationLayout,
    ObligationParser,
    Reserve
} from "../models"
import BufferLayout from "buffer-layout";
import {LastUpdateLayout} from "@/api/models/state/lastUpdate";
import {PublicKey} from "@solana/web3.js";
import BigNumber from "bignumber.js";
import {eX} from "@/utils/helpers";
let reserveSet:Set<PublicKey>
// TODO Bonfida pool LENDING_PROGRAM_ID
export async function getObligation(ownerAddress:PublicKey,lendingMarketID:PublicKey,lendingProgaramID:PublicKey):Promise<Detail<Obligation>[]>{
    if (!reserveSet){
        reserveSet = new Set<PublicKey>();
        RESERVE_IDS.map(reservePublicKey => {
            reserveSet.add(reservePublicKey)
        })
        LP_RESERVE_IDS.map(reserveConfig=>{
            reserveSet.add(reserveConfig.reserveID)
        })
    }
    const connection = await getConnection()
    const accountInfos = await connection.getProgramAccounts(lendingProgaramID,{
        filters:[
            {
                dataSize: ObligationLayout.span
            },
            {
                memcmp: {
                    offset: BufferLayout.u8('version').span+LastUpdateLayout.span+32,
                    /** data to match, as base-58 encoded string and limited to less than 129 bytes */
                    bytes: ownerAddress.toBase58()
                }
            }

        ]
    })
    const resultArray = new Array<Detail<Obligation>>();
    accountInfos.map(function (item):any{
        const obligationParser = ObligationParser(item.pubkey,item.account)
        if (obligationParser.info.lendingMarket.equals(lendingMarketID)){
            resultArray.push(
                obligationParser
            )
        }
    })
    resultArray.sort( ( a, b)=>{
        return b.pubkey.toString().localeCompare(a.pubkey.toString())
    })
    return resultArray
}
// @ts-ignore
export async function getObligationByPublicKey(ownerAddress:PublicKey,lendingMarketIDArray:PublicKey[],lendingProgaramID:PublicKey):Promise<Map<string, Detail<Obligation>[]>>{
    const connection = await getConnection()
    const accountInfos = await connection.getProgramAccounts(lendingProgaramID,{
        filters:[
            {
                dataSize: ObligationLayout.span
            },
            {
                memcmp: {
                    offset: BufferLayout.u8('version').span+LastUpdateLayout.span+32,
                    /** data to match, as base-58 encoded string and limited to less than 129 bytes */
                    bytes: ownerAddress.toBase58()
                }
             }

        ]
    })
    const resultMap = new Map<string,Detail<Obligation>[]>()
    lendingMarketIDArray.forEach((lendingMarketID)=>{
        const resultArray = new Array<Detail<Obligation>>();
        accountInfos.map(function (item):any{
            const obligationParser = ObligationParser(item.pubkey,item.account)
            if (obligationParser.info.lendingMarket.equals(lendingMarketID)){
                resultArray.push(
                    obligationParser
                )
            }
        })
        resultArray.sort( ( a, b)=>{
            return b.pubkey.toString().localeCompare(a.pubkey.toString())
        })
        resultMap.set(LENDING_MARKET_CONFIGS.find((config)=>config.lendingMarket.pubkey.equals(lendingMarketID))!.poolType,resultArray)
    })
    return resultMap
}
export async function getObligations(lendingMarketAddress: PublicKey,reserveArray:Array<Detail<Reserve>>,lendingProgramID:PublicKey): Promise<Array<Detail<Obligation>>> {
    const connection = await getConnection();
    const allAccountInfoArray =
        await Promise.all([
             connection.getProgramAccounts(lendingProgramID,
            {
                filters:[
                    {
                        dataSize: ObligationLayout.span
                    }
                ]
            }
        ),
             connection.getProgramAccounts(LENDING_PROGRAM_ID_BONFIDA,
                {
                    filters:[
                        {
                            dataSize: ObligationLayout.span
                        }
                    ]
                }
            ),
        ])
    const allAccountInfos =allAccountInfoArray[0].concat(allAccountInfoArray[1])
    const lpObligations = new Array<Detail<Obligation>>();
    const resultArray = new Array<Detail<Obligation>>();
    const top10BorrowUser = new Array<Detail<Obligation>>();
    const deficitUsers = new Array<Detail<Obligation>>()
    allAccountInfos.map(function(item): any {

        const obligation = ObligationParser(item.pubkey, item.account);
        if (obligation.info.lendingMarket.equals(lendingMarketAddress)) {
            if (obligation.info.borrows.length ==0){
                return
            }
            let hasLP = false
            let logoSource
            obligation.info.depositedValueInBibNumber = new BigNumber(0)
            obligation.info.borrowLimitValueInBibNumber = new BigNumber(0)
            obligation.info.deposits.map((deposit)=>{
                reserveArray.map((reserve)=>{
                    if (deposit.depositReserve.equals(reserve.pubkey)){
                        if (reserve.info.isLP){
                            hasLP = true
                            deposit.isLP = true
                        }
                        deposit.depositedInTokenUnit = eX(deposit.depositedAmount.toString(),-reserve.info.liquidity.mintDecimals).div(reserve.info.liquidity.exchangeRate)
                        deposit.depositedMarketValue = deposit.depositedInTokenUnit.times(reserve.info.liquidity.liquidityPrice)

                        deposit.reserve = reserve
                        try {
                            logoSource = require(`../../assets/coin/asset_${reserve.info.liquidity.name}.${reserve.info.isLP?'png':'svg'}`);
                        } catch (e) {
                            logoSource = require(`../../assets/coin/token.svg`);
                        }
                        // @ts-ignore
                        deposit.reserve.logoSource = logoSource
                        obligation.info.depositedValueInBibNumber =  obligation.info.depositedValueInBibNumber.plus(deposit.depositedMarketValue)
                        obligation.info.borrowLimitValueInBibNumber = obligation.info.borrowLimitValueInBibNumber.plus(deposit.depositedMarketValue.times(new BigNumber(reserve.info.config.liquidationThreshold.toString())).div(100))
                    }
                })

            })
            obligation.info.borrowedValueInBigNumber = new BigNumber(0)
            obligation.info.borrows.map((borrow)=>{
                reserveArray.map((reserve)=>{
                    if (borrow.borrowReserve.equals(reserve.pubkey)){

                        const compoundedInterestRate = new BigNumber(reserve.info.liquidity.cumulativeBorrowRateWads.toString())
                            .div(new BigNumber(borrow.cumulativeBorrowRateWads.toString()))
                        borrow.borrowAmountValueInTokenUnit = compoundedInterestRate.times(eX(borrow.borrowedAmountWads.toString(),-18-reserve.info.liquidity.mintDecimals))
                        borrow.marketValueInBigNumber = borrow.borrowAmountValueInTokenUnit.times(reserve.info.liquidity.liquidityPrice)
                        borrow.reserve = reserve
                        obligation.info.borrowedValueInBigNumber =  obligation.info.borrowedValueInBigNumber.plus(borrow.marketValueInBigNumber)
                        try {
                            logoSource = require(`../../assets/coin/asset_${reserve.info.liquidity.name}.${reserve.info.isLP?'png':'svg'}`);
                        } catch (e) {
                            logoSource = require(`../../assets/coin/token.svg`);
                        }
                        // @ts-ignore
                        borrow.reserve.logoSource = logoSource
                    }
                })
            })
            if (obligation.info.borrowedValueInBigNumber.isGreaterThan(500)){
                top10BorrowUser.push(obligation)
            }
            if (obligation.info.depositedValueInBibNumber.isLessThan(10)) {
                deficitUsers.push(obligation)
            }
            const rate = obligation.info.borrowedValueInBigNumber.div(obligation.info.borrowLimitValueInBibNumber.isZero()?1:obligation.info.borrowLimitValueInBibNumber)
            obligation.info.debtRatio = rate
            if (hasLP){
                lpObligations.push(obligation)
            }
            if (obligation.info.deposits.length>0&&rate.isGreaterThan(0.9))
            {
                let hasBTCOrSOETH = false
                let allDepositValue = new BigNumber(0)
                if (rate.isGreaterThan(0.99))
                {
                    obligation.info.deposits.map((deposit)=>{
                        allDepositValue = deposit.depositedMarketValue.plus(allDepositValue)
                        if (['9oxCAYbaien8bqjhsGpfVGEV32GJyQ8fSRMsPzczHTEb', 'By2vzoMtUjtziiUZkBd4V5pwFNKeEz4XeZsBXBLGPtoL'].includes(deposit.depositReserve.toString())) {
                            hasBTCOrSOETH = true
                        }
                    })
                    if (allDepositValue.isLessThan(0.1)){
                        return
                    }
                }

                if (hasBTCOrSOETH && rate.isGreaterThan(1) && obligation.info.deposits.length === 1) return
                const sortBorrows = obligation.info.borrows.slice()
                const sortDeposits = obligation.info.deposits.slice()
                sortBorrows.sort((b:any,a:any)=>{
                    return a.marketValueInBigNumber.minus(b.marketValueInBigNumber).toNumber()
                })
                sortDeposits.sort((b:any,a:any)=>{
                    return a.depositedMarketValue.minus(b.depositedMarketValue).toNumber()
                })

                obligation.info.sortBorrows = sortBorrows
                obligation.info.sortDeposits = sortDeposits
                resultArray.push(obligation);
            }
        }
    });
    lpObligations.sort((a,b)=>{
        return b.info.debtRatio.toNumber()-a.info.debtRatio.toNumber()
    })
    // console.log("")
    // console.log("lpObligations.length",lpObligations.length)
    // lpObligations.map(obligation=>{
    //     console.log("")
    //     console.log("owner",obligation.info.owner.toString())
    //     console.log("debtRatio",obligation.info.debtRatio.toFixed(4))
    //     console.log("deposit:")
    //     console.log("depositedValue",obligation.info.depositedValueInBibNumber.toFixed(4))
    //     obligation.info.deposits.map((deposit)=> {
    //         reserveArray.map((reserve) => {
    //             if (deposit.depositReserve.equals(reserve.pubkey)) {
    //                 console.log("   ",reserve.info.liquidity.name);
    //                 console.log("   ",deposit.depositedInTokenUnit.toFixed(4));
    //                 console.log("   ",deposit.depositedMarketValue.toFixed(4));
    //             }
    //         })
    //     })
    //     console.log("borrow:")
    //     console.log("borrowLimitValue", obligation.info.borrowLimitValueInBibNumber.toFixed(4))
    //     console.log("borrowedValue", obligation.info.borrowedValueInBigNumber.toFixed(4))
    //     obligation.info.borrows.map((borrow) => {
    //         reserveArray.map((reserve) => {
    //             if (borrow.borrowReserve.equals(reserve.pubkey)) {
    //                 console.log("   ",reserve.info.liquidity.name);
    //                 console.log("   ",borrow.borrowAmountValueInTokenUnit.toFixed(4));
    //                 console.log("   ",borrow.marketValueInBigNumber.toFixed(4));
    //             }
    //         })
    //     })
    // })
    top10BorrowUser.sort((a:Detail<Obligation>,b:Detail<Obligation>)=>{
        let totalBorrowB = new BigNumber(0)
            b.info.borrows.forEach((item)=>{
                totalBorrowB = totalBorrowB.plus(item.marketValueInBigNumber)
        })
        let totalBorrowA = new BigNumber(0)
        a.info.borrows.forEach((item)=>{
            totalBorrowA = totalBorrowA.plus(item.marketValueInBigNumber)
        })
        //@ts-ignore
        return totalBorrowB.minus(totalBorrowA).toNumber()
    })
    let res = ''
    top10BorrowUser.forEach((item)=>{
        let totalBorrow = new BigNumber(0)
        item.info.borrows.forEach((borrow)=>{
            totalBorrow = totalBorrow.plus(borrow.marketValueInBigNumber)
        })
        // console.log('User',item.info.owner.toString())
        // console.log('Borrow',totalBorrow.toFixed(2))
        // res = res + 'User:'+item.info.owner.toString()+'\n'+'Borrow $'+totalBorrow.toFixed(2)+'\n'
    })
    // console.log('deficitUsers',deficitUsers)
    deficitUsers.forEach((item) => {
        let totalBorrow = new BigNumber(0)
        const borrows = [] as any
        const reserveStrings = RESERVE_IDS.map((item) => {
            return item.toString().toLowerCase()
        })
        item.info.borrows.forEach((borrow)=>{
            const index = reserveStrings.indexOf(borrow.borrowReserve.toString().toLowerCase())
            const reserveFullName = RESERVE_FULLNAMES[index]
            borrows.push({
                symbol:reserveFullName,
                value:borrow?.marketValueInBigNumber?.toFixed(2
                )
            })
            totalBorrow = totalBorrow.plus(borrow.marketValueInBigNumber)
        })
        // console.log('User',item.info.owner.toString())
        // console.log('Borrow',totalBorrow.toFixed(2))
        if (totalBorrow.isGreaterThan(100)){
            res = res +item.info.owner.toString()+'\n'+totalBorrow.toFixed(2)+'borrow details :'+JSON.stringify(borrows)+'\n'
        }


    })
    // console.log(res)
    return resultArray;
}
